import React from 'react';
import { Link } from 'react-router-dom';
interface Props {
  title: string;
  linkLabel?: string;
  linkTo?: string;
  children: React.ReactNode;
  className?: string;
}
export function Panel({
  title,
  linkLabel,
  linkTo,
  children,
  className = ''
}: Props) {
  return <section className={`flex flex-col rounded-card border border-line bg-white ${className}`} data-id="element-201" data-mp="1kb1jqxow4n10">
      <header className="flex items-center justify-between gap-3 px-5 pb-3 pt-5" data-id="element-202" data-mp="1fgnjagvdfpph">
        <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-203" data-mp="1t8248t8ua0z6">{title}</h2>
        {linkLabel && linkTo && <Link to={linkTo} className="text-sm font-medium text-accent underline decoration-accent/40 underline-offset-4 transition-colors duration-150 hover:text-accent-deep hover:decoration-accent" data-id="element-204" data-mp="2382nkf6pkh3d">
            {linkLabel}
          </Link>}
      </header>
      <div className="flex-1 px-2 pb-2" data-id="element-205" data-mp="3uymsiqh63zj">{children}</div>
    </section>;
}
export function PanelEmpty({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="px-3 py-8 text-center text-sm text-ink-muted" data-id="element-206" data-mp="8gkllx6bhxw1">{children}</p>;
}

/** Ens rækkestil for lister i panelerne. */
export const rowClass = 'group flex items-center gap-3 rounded-xl px-3 py-3 transition-colors duration-150 ease-smooth hover:bg-canvas-deep';